import {Injectable} from '@angular/core';
import {DipRegistrationStore} from '../stores/dip-registration-store';
import {WebMetricState} from "./dip-web-metric-state.model";

@Injectable()
export class WebMetricStore extends DipRegistrationStore<WebMetricState> {

  constructor() {
    super(new WebMetricState());
  }

  setLaunchFrom(launchFrom: string) {  this.setState ({    ...this.state,    launchFrom  });}
}
